var _linearGradient, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPytorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 70,
    height: 70,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "hqBdiw7hWbh_bf9we5wHOa_jH4BpkMnRrU5_gr1",
    x1: 18.6,
    x2: 29.117,
    y1: 10.403,
    y2: 42.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hqBdiw7hWbh_bf9we5wHOa_jH4BpkMnRrU5_gr1)",
    d: "M36.277,15.251C39.276,18.384,41,22.571,41,27c0,9.374-7.626,17-17,17S7,36.374,7,27 c0-8.518,8.812-15.984,15.894-21.983c0.379-0.321,0.74-0.629,1.106-0.941v5.25C17.865,14.559,11,20.837,11,27 c0,7.168,5.832,13,13,13s13-5.832,13-13c0-3.428-1.363-6.657-3.709-9.062L36.277,15.251z M30,10c-1.105,0-2,0.895-2,2s0.895,2,2,2 s2-0.895,2-2S31.105,10,30,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorch);
export default __webpack_public_path__ + "static/media/pytorch.ef58b9b9b1d905570eeb7f93ddc9519f.svg";
export { ForwardRef as ReactComponent };